import { render, staticRenderFns } from "./ModalProductAddedToCart.vue?vue&type=template&id=12dcaf70&scoped=true"
import script from "./ModalProductAddedToCart.vue?vue&type=script&lang=js"
export * from "./ModalProductAddedToCart.vue?vue&type=script&lang=js"
import style0 from "./ModalProductAddedToCart.vue?vue&type=style&index=0&id=12dcaf70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12dcaf70",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommercialOperationBadge: require('/app/components/CommercialOperationBadge.vue').default,AlertSellInSingleCopy: require('/app/components/AlertSellInSingleCopy.vue').default,HomologationWarningBadge: require('/app/components/HomologationWarningBadge.vue').default,AssociatedProducts: require('/app/components/AssociatedProducts.vue').default})
